import React, { useEffect, useState } from 'react';
import Header from '../componets/header/header';
import about1 from '../../assets/about1.webp';
import about2 from '../../assets/about2.webp';
import CEO from '../../assets/ceo.webp';
import mission from '../../assets/mission.webp';
import vision from '../../assets/vision.webp';
import values from '../../assets/values.webp';
import why1 from '../../assets/why1.webp';
// @ts-ignore: Allow side-effect CSS imports without type declarations
import './About.css';
// @ts-ignore: Allow side-effect CSS imports without type declarations
import '../homepage/homepage.css'
import Footer from '../componets/footer/footer';
import loading from '../../assets/loading.gif';
import CookieConsent from '../componets/cookies/CookieConsent';

import { Helmet } from 'react-helmet';

const About: React.FC = () => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const images = document.querySelectorAll("img");
        let loaded = 0;

        const checkAllImagesLoaded = () => {
            loaded++;
            if (loaded === images.length) {
                setIsLoading(false);
            }
        };

        images.forEach((img) => {
            if (img.complete) {
                checkAllImagesLoaded();
            } else {
                img.addEventListener('load', checkAllImagesLoaded);
                img.addEventListener('error', checkAllImagesLoaded);
            }
        });

        return () => {
            images.forEach((img) => {
                img.removeEventListener('load', checkAllImagesLoaded);
                img.removeEventListener('error', checkAllImagesLoaded);
            });
        };
    }, []);

    const whyUsContent = [
        <> <strong>India’sLowest Fee - Exclusive Global Certification Courses</strong></>,
        <> <strong>Elite Expert Faculty</strong> from EA, CFE, CFCS, CAMS, CTP, CPA USA & ACCA backgrounds</>,
        <> <strong>Complete Exam Success Support</strong> with expert mentoring, study guidance & real exam-style mock simulations</>,
        <> <strong>Proven High Success Rate</strong> with student-focused preparation strategies</>,
        <><strong>100% Placement Assistance</strong> for opportunities in India, UAE & USA</>,
        <> <strong>StrongPlacement Track Record</strong> with opportunities in Big 4s, MNCs & global organizations</>,
        <> <strong>Premium Online & Offline Batches</strong> with flexible learning options</>,
        <><strong>Big 4 Alumni & Industry Experts</strong> as Mentors</>,
    ];
    // const Accreditationslogos = [logo4, GAQM, iqn1, iqn2, logo3];

    return (
        <>
            <Helmet>
                <title>About Meantoir Global Academy | EA, CFE, CFS, CFM & IFRS in India</title>
                <meta
                    name="description"
                    content="Meantoir Global Academy is a professional education institute in India offering  EA, CFE, CFS, 
CFM, and Diploma in IFRS certification exam preparation"
                />
                <link rel="canonical" href="https://meantoir.com/about-us" />
            </Helmet>
            {isLoading ? (
                <div className="loading-container">
                    <img src={loading} alt="CFS/CFM experts Kerala & India" className="loading-image" />
                </div>
            ) : (
                <>    <CookieConsent />
                    <Header />
                    <div className="about-page">
                        <div className='content-wrapper'>
                            {/* Hero Section */}
                            <div className="hero-section">
                                <img src={about1} alt="CFS/CFM experts Kerala & India" className="hero-image" />
                                <div className="overlay"></div>
                                <div className="hero-content">
                                    {/* <p>Home → About Us</p> */}
                                    <h1 >About Us</h1>

                                </div>
                            </div>



                            {/* About Us Section */}
                            <div className="about-wrapper-page">
                                <div className="image-container-page">
                                    <img src={about2} alt="About Us" className="about-image-page" />
                                </div>
                                <div className="about-text-page">
                                    <h1 className="homepage-heading">About Us</h1>
                                    <h5 className="about-details-page">
                                        <b>  Meantoir Global Academy </b> is a leading professional certification and training institute in Kerala, India, dedicated to building globally competent professionals in finance, accounting, taxation, forensic accounting, financial crime, compliance, treasury, risk management, and IFRS.
                                    </h5>
                                    <p className="about-details-page">
                                        We offer internationally recognized certifications including    <b>EA (Enrolled Agent – IRS, USA), CFE (Certified Fraud Examiner – ACFE, USA), CFCS (Certified Financial Crime Specialist – ACFCS, USA), CAMS (Certified Anti-Money Laundering Specialist – ACAMS, USA), CTP (Certified Treasury Professional – AFP, USA), CFS (Certified Finance Specialist - IQN, UK), CFM (Certified Finance Manager - GAQM, USA), and Diploma in IFRS (IQN, UK).
                                        </b>
                                    </p>
                                    <p className="about-details-page">
                                        Meantoir Global Academy holds exclusive distinctions as<b> Kerala’s First & Only CFE, CFCS, CAMS, and CTP training provider</b>, along with being <b>India’s First & Only authorized training and exam center for CFS, CFM, and Diploma in IFRS.</b>
                                        With expert faculty, industry-driven curriculum, practical learning, real-world case studies, exam-focused mentoring, and career support, we help students and professionals achieve global career opportunities in India, UAE, USA, UK, Europe, and international markets.

                                    </p>
                                    <p className="about-details-page">
                                        <b>Meantoir Global Academy – Empowering Global Careers Through World-Class Professional Certifications.</b>
                                    </p>
                                </div>
                            </div>
                            <div className="ceo-mission-vision">
                                <div className="info-card">
                                    <div className="icon-box">
                                        <img src={vision} alt="CFS/CFM experts Kerala & India" className="icon-image" />
                                    </div>
                                    <h3 className="info-title">Our Vision</h3>
                                    <p className="info-text">
                                        The vision of Meantoir Global Academy is to empower individuals and organizations to
                                        reach their full potential through professional development and training. We strive to be
                                        a leader in the field, providing comprehensive and industry-relevant
                                        programs that are continuously updated to reflect the latest trends and best practices.
                                    </p>
                                </div>

                                <div className="info-card">
                                    <div className="icon-box">
                                        <img src={mission} alt="CFS/CFM experts Kerala & India" className="icon-image" />
                                    </div>
                                    <h3 className="info-title">Our Mission</h3>
                                    <p className="info-text">
                                        Meantoir Global Academy is dedicated to becoming the premier provider of professional
                                        development and training in India and the region. Our mission is to create a supportive and nurturing learning environment where students can acquire the knowledge and
                                        skills they need to excel in their field and achieve their career goals.
                                    </p>
                                </div>

                                <div className="info-card">
                                    <div className="icon-box">
                                        <img src={values} alt="Values Icon" className="icon-image" />
                                    </div>
                                    <h3 className="info-title">Our Values</h3>
                                    <ul className="info-text" style={{ textAlign: 'left', paddingLeft: '20px' }}>
                                        <li>Honesty</li>
                                        <li>Commitment to Excellence</li>
                                        <li>Perseverance</li>
                                        <li>Service to Humanity</li>
                                        <li>Consistency</li>
                                    </ul>
                                </div>
                            </div>
                            {/* <section className="accreditation-section">
                                <h2 className="homepage-heading">Accreditations & Affiliations</h2>
                                <div className="accreditation-logos">
                                    {Accreditationslogos.map((logo, index) => (
                                        <div className="accreditation-card" key={index}>
                                            <img src={logo} alt={logo} />
                                        </div>
                                    ))}
                                </div>
                            </section> */}
                            <div className="stats-section">
                                <div className="stat-box" style={{ textAlign: "center" }}>

                                    <span style={{ textAlign: "center", fontSize: "35px", color: "#004080" }}>250+</span>
                                    <br />Students Enrolled
                                </div>
                                <div className="stat-box" style={{ textAlign: "center" }}>

                                    <span style={{ textAlign: "center", fontSize: "35px", color: "#004080" }}>150+</span>
                                    <br />Placed Students
                                </div>
                                <div className="stat-box" style={{ textAlign: "center" }}>

                                    <span style={{ textAlign: "center", fontSize: "35px", color: "#004080" }}>20+</span>
                                    <br />Expert Instructors
                                </div>
                                <div className="stat-box" style={{ textAlign: "center" }}>

                                    <span style={{ textAlign: "center", fontSize: "35px", color: "#004080" }}>100%</span>
                                    <br />Placement Assistance
                                </div>
                            </div>




                            <div className="home-why-wrapper">
                                <div className="home-why-container">
                                    <div className="home-why-left">
                                        <h2 className="homepage-heading">Why Choose Us</h2>
                                        <ul className="home-why-list">
                                            {whyUsContent.map((text, index) => (
                                                <li key={index} className="home-why-list-item"> {text}</li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="home-why-right">
                                        <img src={why1} alt="Finance training institute Kerala" className="home-why-image" />
                                    </div>
                                </div>
                            </div>

                            {/* CEO's Message Section */}
                            <div className="ceo-container">
                                <h2 className="homepage-heading">CEO's Message</h2>
                                <div className="ceo-wrapper">
                                    <div className="ceo-text">
                                        <h4 className="ceo-subtitle">Dear Students & Parents</h4>
                                        <p className="ceo-paragraph">
                                            Welcome to Meantoir Global Academy, where excellence in education meets the pursuit of lifelong learning.
                                        </p>
                                        <p className="ceo-paragraph">
                                            At Meantoir Global Academy, we believe that education is not merely about imparting knowledge but about nurturing critical thinkers, innovative leaders, and socially responsible individuals. Our institution is committed to providing a holistic learning experience that balances academic rigor with opportunities for personal and professional growth.
                                        </p>
                                        <p className="ceo-paragraph">
                                            As we continue to grow and adapt to global changes, our commitment to shaping future leaders remains unwavering. Together, let us forge a path of excellence, inspire one another, and contribute meaningfully to the world.
                                        </p>
                                        <p className="ceo-paragraph">
                                            Thank you for entrusting us with your aspirations and dreams. I look forward to witnessing your achievements and the positive impact you will create in the years to come.
                                        </p>
                                    </div>
                                    <div className="ceo-image-container">
                                        <img src={CEO} alt="CEO" className="ceo-image" />
                                        <div className="ceo-name">
                                            Sebin Sebastian<br />
                                            <span style={{ fontSize: '1rem', fontWeight: 'normal', color: '#666' }}>
                                                Chief Executive Officer
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </>
            )
            }
        </>
    );
};

export default About;